import { SingleIssueEvent } from '@/routes/projectStages/issue/types/issue.ts'
import { EventTypeT } from '@/routes/projectStages/issue/view/activity/EventType.tsx'
import { ReactNode } from 'react'
import { BellRing } from 'lucide-react'

export type EventActionT = {
  link: string
  linkLabel: string
  icon: ReactNode | null
}

export default function getEventAction(
  event: SingleIssueEvent,
  projectStageIri: string | undefined,
): EventActionT | undefined {
  const eventType = event?.eventType as EventTypeT
  if (!eventType) return

  // @ts-expect-error wrong api types
  const issueIri = event.issue?.['@id']
  // @ts-expect-error wrong api types
  const issueTypeIri = event.issue?.issueType

  let linkLabel = 'Zobacz'
  let link = `${projectStageIri}${issueTypeIri}${issueIri}`
  let icon = <BellRing className={`size-4`} />
  //
  // | 'issue.created'
  // | 'issue.published'
  // | 'issue.name.changed'
  // | 'issue.description.changed'
  // | 'issue.recipient.changed'
  // | 'issue.location.changed'
  // | 'issue.duedate.changed'
  // | 'issue.duedate.approaching'
  // | 'issue.duedate.passed'
  // | 'issue.status.changed'
  // | 'issue.labels.added'
  // | 'issue.labels.deleted'
  // | 'issue.attachments.added'
  // | 'issue.attachments.deleted'
  // | 'issue.comments.created'
  // | 'issue.comments.updated'
  // | 'issue.comments.deleted'
  // | 'issue.archived'
  // | 'issue.unarchived'
  //
  switch (eventType) {
    case 'issue.comments.created':
    case 'issue.labels.deleted':
    case 'issue.labels.added':
    case 'issue.status.changed':
    case 'issue.duedate.changed':
    case 'issue.duedate.approaching':
    case 'issue.duedate.passed':
    case 'issue.created':
    case 'issue.comments.deleted':
    case 'issue.comments.updated':
  }

  return { link, linkLabel, icon }
}
